// Generated by observatory/generate.mjs from the owner's package. Do not hand-edit.
import { ObservatoryEdition } from '../../types'

export const edition: ObservatoryEdition = {
  version: '2026-08',
  label: 'agosto de 2026',
  title: 'Observatório Medleve de GLP-1: prescrições de semaglutida e tirzepatida (agosto de 2026) | Medleve',
  description:
    'Dados mensais das prescrições de GLP-1 na Medleve: em agosto de 2026, tirzepatida 51%, semaglutida 49%; Mounjaro 51%, Wegovy 19%, Ozivy 9%. Metodologia aberta, download em CSV.',
  ogTitle: 'Observatório Medleve de GLP-1 — agosto de 2026',
  publicationDate: '2026-10-14',
  nextUpdateDate: null,
  firstPublicationDate: '2026-10-14',
  downloadFiles: [
    'grafico-molecula-2026-08.svg',
    'grafico-marca-2026-08.svg',
    'grafico-semaglutida-2026-08.svg',
    'grafico-inicio-2026-08.svg',
    'grafico-retorno-2026-08.svg',
    'grafico-tempo-retorno-2026-08.svg',
    'grafico-trocas-2026-08.svg',
    'observatorio-glp1-2026-08.csv',
    'observatorio-glp1-2026-08.json'
  ],
  blocks: [
    '\n',
    {
      kind: 'element',
      tag: 'nav',
      attributes: { className: 'crumbs', 'aria-label': 'Trilha de navegação' },
      children: [
        { kind: 'element', tag: 'a', attributes: { href: '/' }, children: ['Medleve'] },
        ' › Observatório de GLP-1'
      ]
    },
    '\n\n',
    {
      kind: 'element',
      tag: 'article',
      attributes: {},
      children: [
        '\n',
        {
          kind: 'element',
          tag: 'header',
          attributes: {},
          children: [
            '\n',
            {
              kind: 'element',
              tag: 'span',
              attributes: { className: 'eyebrow' },
              children: ['Edição de agosto de 2026 · atualização mensal']
            },
            '\n',
            {
              kind: 'element',
              tag: 'h1',
              attributes: {},
              children: ['Observatório Medleve de GLP-1: prescrições de semaglutida e tirzepatida']
            },
            '\n\n',
            {
              kind: 'element',
              tag: 'section',
              attributes: { className: 'ml-summary', id: 'resumo', 'aria-labelledby': 'resumo-titulo' },
              children: [
                '\n',
                { kind: 'element', tag: 'h2', attributes: { id: 'resumo-titulo' }, children: ['Resumo da edição'] },
                '\n',
                {
                  kind: 'element',
                  tag: 'p',
                  attributes: { className: 'ml-summary__answer' },
                  children: [
                    'Em agosto de 2026, a tirzepatida (Mounjaro) representou 51% das prescrições de GLP-1 observadas na Medleve, e a semaglutida, 49%. Mounjaro foi o medicamento mais prescrito (51%), seguido de Wegovy (19%), Ozivy (9%) e Poviztra (4%). 71% das prescrições foram de acompanhamento de tratamento já iniciado. Os dados são da plataforma Medleve e não representam o mercado brasileiro.'
                  ]
                },
                '\n'
              ]
            },
            '\n\n',
            {
              kind: 'element',
              tag: 'p',
              attributes: { className: 'meta' },
              children: [
                '\n',
                {
                  kind: 'element',
                  tag: 'span',
                  attributes: {},
                  children: [
                    'Por ',
                    {
                      kind: 'element',
                      tag: 'a',
                      attributes: { href: '/equipe-medica/carlos-seraphim' },
                      children: ['Dr. Carlos Seraphim']
                    },
                    ', endocrinologista — CRM-SP 156663'
                  ]
                },
                '\n',
                { kind: 'element', tag: 'span', attributes: {}, children: ['Dados: equipe de dados Medleve'] },
                '\n',
                {
                  kind: 'element',
                  tag: 'span',
                  attributes: {},
                  children: [
                    'Publicado em ',
                    {
                      kind: 'element',
                      tag: 'time',
                      attributes: { dateTime: '{{data_de_publicacao_iso}}' },
                      children: ['{{data_de_publicacao}}']
                    }
                  ]
                },
                '\n',
                {
                  kind: 'element',
                  tag: 'span',
                  attributes: {},
                  children: ['Próxima atualização: {{data_da_proxima_atualizacao}}']
                },
                '\n'
              ]
            },
            '\n'
          ]
        },
        '\n\n',
        {
          kind: 'element',
          tag: 'nav',
          attributes: { className: 'toc', id: 'sumario', 'aria-labelledby': 'sumario-titulo' },
          children: [
            { kind: 'element', tag: 'h2', attributes: { id: 'sumario-titulo' }, children: ['Sumário'] },
            {
              kind: 'element',
              tag: 'ol',
              attributes: {},
              children: [
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: {},
                  children: [
                    { kind: 'element', tag: 'a', attributes: { href: '#destaques' }, children: ['Destaques do mês'] }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: {},
                  children: [
                    {
                      kind: 'element',
                      tag: 'a',
                      attributes: { href: '#molecula' },
                      children: ['Tirzepatida ou semaglutida']
                    }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: {},
                  children: [
                    { kind: 'element', tag: 'a', attributes: { href: '#marca' }, children: ['Marcas mais prescritas'] }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: {},
                  children: [
                    {
                      kind: 'element',
                      tag: 'a',
                      attributes: { href: '#semaglutida' },
                      children: ['Marcas de semaglutida']
                    }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: {},
                  children: [
                    {
                      kind: 'element',
                      tag: 'a',
                      attributes: { href: '#inicio-continuidade' },
                      children: ['Início e continuidade']
                    }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: {},
                  children: [
                    {
                      kind: 'element',
                      tag: 'a',
                      attributes: { href: '#retorno' },
                      children: ['Retorno para acompanhamento']
                    }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: {},
                  children: [
                    { kind: 'element', tag: 'a', attributes: { href: '#trocas' }, children: ['Trocas de medicamento'] }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: {},
                  children: [
                    { kind: 'element', tag: 'a', attributes: { href: '#metodologia' }, children: ['Metodologia'] }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: {},
                  children: [
                    {
                      kind: 'element',
                      tag: 'a',
                      attributes: { href: '#dados-abertos' },
                      children: ['Baixar os dados e citar']
                    }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: {},
                  children: [
                    { kind: 'element', tag: 'a', attributes: { href: '#imprensa' }, children: ['Para imprensa'] }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: {},
                  children: [
                    { kind: 'element', tag: 'a', attributes: { href: '#edicoes' }, children: ['Edições anteriores'] }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: {},
                  children: [
                    {
                      kind: 'element',
                      tag: 'a',
                      attributes: { href: '#perguntas-frequentes' },
                      children: ['Perguntas frequentes']
                    }
                  ]
                }
              ]
            }
          ]
        },
        '\n\n',
        {
          kind: 'element',
          tag: 'section',
          attributes: { id: 'destaques', 'aria-labelledby': 'destaques-titulo' },
          children: [
            '\n',
            {
              kind: 'element',
              tag: 'h2',
              attributes: { id: 'destaques-titulo' },
              children: ['Destaques de agosto de 2026']
            },
            '\n',
            {
              kind: 'element',
              tag: 'ul',
              attributes: { className: 'kpis' },
              children: [
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: { className: 'kpi', id: 'destaque-tirzepatida' },
                  children: [
                    { kind: 'element', tag: 'p', attributes: { className: 'kpi__num' }, children: ['51%'] },
                    {
                      kind: 'element',
                      tag: 'p',
                      attributes: { className: 'kpi__lab' },
                      children: ['das prescrições de GLP-1 foram de tirzepatida']
                    },
                    {
                      kind: 'element',
                      tag: 'p',
                      attributes: { className: 'kpi__txt' },
                      children: [
                        'Em agosto de 2026, a tirzepatida representou 51% das prescrições de GLP-1 observadas na Medleve, contra 48% no mês anterior e 35% em agosto de 2025.'
                      ]
                    }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: { className: 'kpi', id: 'destaque-mounjaro' },
                  children: [
                    { kind: 'element', tag: 'p', attributes: { className: 'kpi__num' }, children: ['51%'] },
                    {
                      kind: 'element',
                      tag: 'p',
                      attributes: { className: 'kpi__lab' },
                      children: ['Mounjaro, o medicamento mais prescrito']
                    },
                    {
                      kind: 'element',
                      tag: 'p',
                      attributes: { className: 'kpi__txt' },
                      children: [
                        'Mounjaro foi o medicamento mais frequente nas prescrições de GLP-1 da Medleve em agosto de 2026, com 51% do total.'
                      ]
                    }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: { className: 'kpi', id: 'destaque-wegovy' },
                  children: [
                    { kind: 'element', tag: 'p', attributes: { className: 'kpi__num' }, children: ['19%'] },
                    {
                      kind: 'element',
                      tag: 'p',
                      attributes: { className: 'kpi__lab' },
                      children: ['Wegovy, contra 53% um ano antes']
                    },
                    {
                      kind: 'element',
                      tag: 'p',
                      attributes: { className: 'kpi__txt' },
                      children: [
                        'A participação de Wegovy nas prescrições de GLP-1 observadas na Medleve passou de 53% em agosto de 2025 para 19% em agosto de 2026.'
                      ]
                    }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: { className: 'kpi', id: 'destaque-ozivy' },
                  children: [
                    { kind: 'element', tag: 'p', attributes: { className: 'kpi__num' }, children: ['9%'] },
                    {
                      kind: 'element',
                      tag: 'p',
                      attributes: { className: 'kpi__lab' },
                      children: ['Ozivy, presente desde junho de 2026']
                    },
                    {
                      kind: 'element',
                      tag: 'p',
                      attributes: { className: 'kpi__txt' },
                      children: [
                        'Ozivy, que aparece nas prescrições da Medleve desde junho de 2026, respondeu por 9% das prescrições de GLP-1 em agosto de 2026 (10% no mês anterior).'
                      ]
                    }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: { className: 'kpi', id: 'destaque-continuidade' },
                  children: [
                    { kind: 'element', tag: 'p', attributes: { className: 'kpi__num' }, children: ['71%'] },
                    {
                      kind: 'element',
                      tag: 'p',
                      attributes: { className: 'kpi__lab' },
                      children: ['das prescrições foram de acompanhamento']
                    },
                    {
                      kind: 'element',
                      tag: 'p',
                      attributes: { className: 'kpi__txt' },
                      children: [
                        'Em agosto de 2026, 71% das prescrições de GLP-1 da Medleve foram de acompanhamento (retorno) e 29% de início de tratamento.'
                      ]
                    }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: { className: 'kpi', id: 'destaque-retorno' },
                  children: [
                    { kind: 'element', tag: 'p', attributes: { className: 'kpi__num' }, children: ['29%'] },
                    {
                      kind: 'element',
                      tag: 'p',
                      attributes: { className: 'kpi__lab' },
                      children: ['voltaram em até 90 dias (coorte de maio de 2026)']
                    },
                    {
                      kind: 'element',
                      tag: 'p',
                      attributes: { className: 'kpi__txt' },
                      children: [
                        'Entre pacientes que fizeram a primeira consulta na Medleve em maio de 2026, 29% voltaram para uma nova consulta em até 90 dias.'
                      ]
                    }
                  ]
                }
              ]
            },
            '\n'
          ]
        },
        '\n\n',
        {
          kind: 'cta',
          variant: 'compact',
          position: 1,
          support: 'Quer saber se um tratamento com GLP-1 é indicado para você?'
        },
        '\n\n',
        {
          kind: 'element',
          tag: 'section',
          attributes: { id: 'molecula', 'aria-labelledby': 'molecula-titulo' },
          children: [
            '\n',
            {
              kind: 'element',
              tag: 'h2',
              attributes: { id: 'molecula-titulo' },
              children: ['Tirzepatida ou semaglutida: qual molécula é mais prescrita?']
            },
            '\n',
            {
              kind: 'element',
              tag: 'p',
              attributes: {},
              children: [
                'Em agosto de 2026, a ',
                { kind: 'element', tag: 'a', attributes: { href: '/tirzepatida' }, children: ['tirzepatida'] },
                ' respondeu por 51% das prescrições de GLP-1 observadas na Medleve, e a ',
                { kind: 'element', tag: 'a', attributes: { href: '/semaglutida' }, children: ['semaglutida'] },
                ', por 49%. Em agosto de 2025, a proporção era inversa: 35% de tirzepatida e 56% de semaglutida. A tirzepatida passou à frente em novembro de 2025. Entre abril e julho de 2026, sua participação recuou de 61% para 48% e voltou a 51% em agosto de 2026.'
              ]
            },
            '\n',
            {
              kind: 'element',
              tag: 'figure',
              attributes: {},
              children: [
                '\n',
                {
                  kind: 'element',
                  tag: 'figcaption',
                  attributes: {},
                  children: ['Participação por molécula nas prescrições de GLP-1 da Medleve (%)']
                },
                '\n',
                {
                  kind: 'chart',
                  file: 'grafico-molecula-2026-08.svg',
                  title: 'Mix por molécula nas prescrições de GLP-1 da Medleve, agosto de 2025 a agosto de 2026',
                  description:
                    'Barras empilhadas mensais. A tirzepatida passou de 35% para 51%; a semaglutida representou 49% em agosto de 2026.',
                  labels: [
                    '0%',
                    '25%',
                    '50%',
                    '75%',
                    '100%',
                    'ago/25',
                    'set/25',
                    'out/25',
                    'nov/25',
                    'dez/25',
                    'jan/26',
                    'fev/26',
                    'mar/26',
                    'abr/26',
                    'mai/26',
                    'jun/26',
                    'jul/26',
                    'ago/26'
                  ],
                  width: 720,
                  height: 300
                },
                {
                  kind: 'element',
                  tag: 'ul',
                  attributes: { className: 'legend' },
                  children: [
                    {
                      kind: 'element',
                      tag: 'li',
                      attributes: {},
                      children: [
                        {
                          kind: 'element',
                          tag: 'span',
                          attributes: { className: 'sw', style: { background: 'rgb(63, 84, 128)' } },
                          children: []
                        },
                        'Tirzepatida'
                      ]
                    },
                    {
                      kind: 'element',
                      tag: 'li',
                      attributes: {},
                      children: [
                        {
                          kind: 'element',
                          tag: 'span',
                          attributes: { className: 'sw', style: { background: 'rgb(217, 169, 58)' } },
                          children: []
                        },
                        'Semaglutida'
                      ]
                    },
                    {
                      kind: 'element',
                      tag: 'li',
                      attributes: {},
                      children: [
                        {
                          kind: 'element',
                          tag: 'span',
                          attributes: { className: 'sw', style: { background: 'rgb(185, 179, 163)' } },
                          children: []
                        },
                        'Outras'
                      ]
                    }
                  ]
                },
                '\n',
                {
                  kind: 'element',
                  tag: 'p',
                  attributes: { className: 'source' },
                  children: [
                    'Fonte: Observatório Medleve de GLP-1, edição de agosto de 2026. Percentuais arredondados.'
                  ]
                },
                '\n',
                {
                  kind: 'element',
                  tag: 'details',
                  attributes: { className: 'datatable' },
                  children: [
                    { kind: 'element', tag: 'summary', attributes: {}, children: ['Ver tabela de dados'] },
                    {
                      kind: 'element',
                      tag: 'div',
                      attributes: { className: 'tscroll' },
                      children: [
                        {
                          kind: 'element',
                          tag: 'table',
                          attributes: {},
                          children: [
                            {
                              kind: 'element',
                              tag: 'caption',
                              attributes: {},
                              children: ['Participação por molécula nas prescrições de GLP-1 (%)']
                            },
                            {
                              kind: 'element',
                              tag: 'thead',
                              attributes: {},
                              children: [
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['Mês'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['ago/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['set/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['out/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['nov/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['dez/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['jan/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['fev/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['mar/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['abr/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['mai/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['jun/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['jul/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['ago/26'] }
                                  ]
                                }
                              ]
                            },
                            {
                              kind: 'element',
                              tag: 'tbody',
                              attributes: {},
                              children: [
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    {
                                      kind: 'element',
                                      tag: 'th',
                                      attributes: { scope: 'row' },
                                      children: ['Tirzepatida']
                                    },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['35%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['38%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['46%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['55%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['61%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['63%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['62%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['60%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['61%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['57%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['52%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['48%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['51%'] }
                                  ]
                                },
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    {
                                      kind: 'element',
                                      tag: 'th',
                                      attributes: { scope: 'row' },
                                      children: ['Semaglutida']
                                    },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['56%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['58%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['52%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['43%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['37%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['36%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['37%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['39%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['38%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['42%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['47%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['50%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['49%'] }
                                  ]
                                },
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    { kind: 'element', tag: 'th', attributes: { scope: 'row' }, children: ['Outras'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['9%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['4%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                '\n'
              ]
            },
            '\n'
          ]
        },
        '\n\n',
        {
          kind: 'element',
          tag: 'section',
          attributes: { id: 'marca', 'aria-labelledby': 'marca-titulo' },
          children: [
            '\n',
            {
              kind: 'element',
              tag: 'h2',
              attributes: { id: 'marca-titulo' },
              children: ['Quais marcas de GLP-1 são mais prescritas?']
            },
            '\n',
            {
              kind: 'element',
              tag: 'p',
              attributes: {},
              children: [
                { kind: 'element', tag: 'a', attributes: { href: '/mounjaro' }, children: ['Mounjaro'] },
                ' foi o medicamento mais prescrito em agosto de 2026, com 51% das prescrições de GLP-1. ',
                { kind: 'element', tag: 'a', attributes: { href: '/wegovy' }, children: ['Wegovy'] },
                ' veio em seguida, com 19%, contra 53% em agosto de 2025. Entre as semaglutidas lançadas em 2026, ',
                { kind: 'element', tag: 'a', attributes: { href: '/ozivy' }, children: ['Ozivy'] },
                ' chegou a 9% e ',
                { kind: 'element', tag: 'a', attributes: { href: '/poviztra' }, children: ['Poviztra'] },
                ' a 4%. ',
                { kind: 'element', tag: 'a', attributes: { href: '/ozempic' }, children: ['Ozempic'] },
                ' ficou em 1%. O ',
                { kind: 'element', tag: 'a', attributes: { href: '/semavy' }, children: ['Semavy'] },
                ' ainda não aparece com base suficiente para publicação.'
              ]
            },
            '\n',
            {
              kind: 'element',
              tag: 'figure',
              attributes: {},
              children: [
                '\n',
                {
                  kind: 'element',
                  tag: 'figcaption',
                  attributes: {},
                  children: ['Participação por marca nas prescrições de GLP-1 da Medleve (%)']
                },
                '\n',
                {
                  kind: 'chart',
                  file: 'grafico-marca-2026-08.svg',
                  title: 'Mix por marca nas prescrições de GLP-1 da Medleve, agosto de 2025 a agosto de 2026',
                  description:
                    'Linhas mensais por marca. Em agosto de 2026: Mounjaro 51%, Wegovy 19%, Ozivy 9%, Poviztra 4%. Quebra de série em junho de 2026.',
                  labels: [
                    '0%',
                    '10%',
                    '20%',
                    '30%',
                    '40%',
                    '50%',
                    '60%',
                    '70%',
                    'ago/25',
                    'set/25',
                    'out/25',
                    'nov/25',
                    'dez/25',
                    'jan/26',
                    'fev/26',
                    'mar/26',
                    'abr/26',
                    'mai/26',
                    'jun/26',
                    'jul/26',
                    'ago/26',
                    'quebra de série'
                  ],
                  width: 720,
                  height: 300
                },
                {
                  kind: 'element',
                  tag: 'ul',
                  attributes: { className: 'legend' },
                  children: [
                    {
                      kind: 'element',
                      tag: 'li',
                      attributes: {},
                      children: [
                        {
                          kind: 'element',
                          tag: 'span',
                          attributes: { className: 'sw', style: { background: 'rgb(63, 84, 128)' } },
                          children: []
                        },
                        'Mounjaro'
                      ]
                    },
                    {
                      kind: 'element',
                      tag: 'li',
                      attributes: {},
                      children: [
                        {
                          kind: 'element',
                          tag: 'span',
                          attributes: { className: 'sw', style: { background: 'rgb(217, 169, 58)' } },
                          children: []
                        },
                        'Wegovy'
                      ]
                    },
                    {
                      kind: 'element',
                      tag: 'li',
                      attributes: {},
                      children: [
                        {
                          kind: 'element',
                          tag: 'span',
                          attributes: { className: 'sw', style: { background: 'rgb(42, 157, 143)' } },
                          children: []
                        },
                        'Ozivy'
                      ]
                    },
                    {
                      kind: 'element',
                      tag: 'li',
                      attributes: {},
                      children: [
                        {
                          kind: 'element',
                          tag: 'span',
                          attributes: { className: 'sw', style: { background: 'rgb(192, 86, 122)' } },
                          children: []
                        },
                        'Poviztra'
                      ]
                    },
                    {
                      kind: 'element',
                      tag: 'li',
                      attributes: {},
                      children: [
                        {
                          kind: 'element',
                          tag: 'span',
                          attributes: { className: 'sw', style: { background: 'rgb(140, 122, 184)' } },
                          children: []
                        },
                        'Ozempic'
                      ]
                    },
                    {
                      kind: 'element',
                      tag: 'li',
                      attributes: {},
                      children: [
                        {
                          kind: 'element',
                          tag: 'span',
                          attributes: { className: 'sw', style: { background: 'rgb(138, 148, 156)', opacity: '0.8' } },
                          children: []
                        },
                        'Semaglutida (marca não identificada)'
                      ]
                    }
                  ]
                },
                '\n',
                {
                  kind: 'element',
                  tag: 'p',
                  attributes: { className: 'source' },
                  children: [
                    'Fonte: Observatório Medleve de GLP-1, edição de agosto de 2026. "<1%" é representado como 0,5% no gráfico.'
                  ]
                },
                '\n',
                {
                  kind: 'element',
                  tag: 'details',
                  attributes: { className: 'datatable' },
                  children: [
                    { kind: 'element', tag: 'summary', attributes: {}, children: ['Ver tabela de dados'] },
                    {
                      kind: 'element',
                      tag: 'div',
                      attributes: { className: 'tscroll' },
                      children: [
                        {
                          kind: 'element',
                          tag: 'table',
                          attributes: {},
                          children: [
                            {
                              kind: 'element',
                              tag: 'caption',
                              attributes: {},
                              children: ['Participação por marca nas prescrições de GLP-1 (%)']
                            },
                            {
                              kind: 'element',
                              tag: 'thead',
                              attributes: {},
                              children: [
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['Mês'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['ago/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['set/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['out/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['nov/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['dez/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['jan/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['fev/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['mar/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['abr/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['mai/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['jun/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['jul/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['ago/26'] }
                                  ]
                                }
                              ]
                            },
                            {
                              kind: 'element',
                              tag: 'tbody',
                              attributes: {},
                              children: [
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    {
                                      kind: 'element',
                                      tag: 'th',
                                      attributes: { scope: 'row' },
                                      children: ['Mounjaro']
                                    },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['35%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['38%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['44%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['53%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['59%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['62%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['61%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['60%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['61%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['57%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['52%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['48%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['51%'] }
                                  ]
                                },
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    { kind: 'element', tag: 'th', attributes: { scope: 'row' }, children: ['Wegovy'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['53%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['54%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['48%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['38%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['32%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['32%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['33%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['34%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['33%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['35%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['28%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['19%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['19%'] }
                                  ]
                                },
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    { kind: 'element', tag: 'th', attributes: { scope: 'row' }, children: ['Ozivy'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['9%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['10%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['9%'] }
                                  ]
                                },
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    {
                                      kind: 'element',
                                      tag: 'th',
                                      attributes: { scope: 'row' },
                                      children: ['Poviztra']
                                    },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['<1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['<1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['<1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['<1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['6%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['4%'] }
                                  ]
                                },
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    { kind: 'element', tag: 'th', attributes: { scope: 'row' }, children: ['Semavy'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] }
                                  ]
                                },
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    { kind: 'element', tag: 'th', attributes: { scope: 'row' }, children: ['Ozempic'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['3%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['3%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['4%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['3%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['3%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['3%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] }
                                  ]
                                },
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    {
                                      kind: 'element',
                                      tag: 'th',
                                      attributes: { scope: 'row' },
                                      children: ['Semaglutida (marca não identificada)']
                                    },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['<1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['<1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['<1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['<1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['<1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['<1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['<1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['6%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['13%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['15%'] }
                                  ]
                                },
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    { kind: 'element', tag: 'th', attributes: { scope: 'row' }, children: ['Outros'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['10%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['5%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['6%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['4%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['5%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['3%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['3%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['3%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['3%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                '\n'
              ]
            },
            '\n',
            {
              kind: 'element',
              tag: 'aside',
              attributes: {
                className: 'ml-callout ml-callout--warn',
                id: 'quebra-de-serie',
                role: 'note',
                'aria-labelledby': 'quebra-titulo'
              },
              children: [
                '\n',
                {
                  kind: 'element',
                  tag: 'h3',
                  attributes: { id: 'quebra-titulo', className: 'ml-callout__title' },
                  children: ['Quebra de série a partir de junho de 2026']
                },
                '\n',
                {
                  kind: 'element',
                  tag: 'p',
                  attributes: {},
                  children: [
                    'Desde junho de 2026, parte das prescrições de semaglutida não informa a marca (15% em agosto de 2026). Por isso, as participações de Ozivy, Poviztra e Semavy podem estar subestimadas a partir desse mês.'
                  ]
                },
                '\n'
              ]
            },
            '\n'
          ]
        },
        '\n\n',
        {
          kind: 'element',
          tag: 'section',
          attributes: { id: 'semaglutida', 'aria-labelledby': 'sema-titulo' },
          children: [
            '\n',
            {
              kind: 'element',
              tag: 'h2',
              attributes: { id: 'sema-titulo' },
              children: ['Quais marcas de semaglutida são mais prescritas?']
            },
            '\n',
            {
              kind: 'element',
              tag: 'p',
              attributes: {},
              children: [
                'Entre as prescrições de semaglutida observadas na Medleve em agosto de 2026, 39% foram de Wegovy, 18% de Ozivy e 8% de Poviztra. Até maio de 2026, Wegovy respondia por 83% das prescrições de semaglutida. Entre as prescrições de tirzepatida, 100% foram de Mounjaro.'
              ]
            },
            '\n',
            {
              kind: 'element',
              tag: 'figure',
              attributes: {},
              children: [
                '\n',
                {
                  kind: 'element',
                  tag: 'figcaption',
                  attributes: {},
                  children: ['Marcas dentro das prescrições de semaglutida, agosto de 2026 (%)']
                },
                '\n',
                {
                  kind: 'chart',
                  file: 'grafico-semaglutida-2026-08.svg',
                  title: 'Marcas dentro das prescrições de semaglutida, agosto de 2026',
                  description: 'Wegovy 39%, Ozivy 18%, Poviztra 8%.',
                  labels: [
                    'Wegovy',
                    '39%',
                    'Sem marca informada',
                    '30%',
                    'Ozivy',
                    '18%',
                    'Poviztra',
                    '8%',
                    'Ozempic',
                    '2%',
                    'Rybelsus',
                    '2%'
                  ],
                  width: 720,
                  height: 214
                },
                '\n',
                {
                  kind: 'element',
                  tag: 'p',
                  attributes: { className: 'source' },
                  children: ['Fonte: Observatório Medleve de GLP-1, edição de agosto de 2026.']
                },
                '\n',
                {
                  kind: 'element',
                  tag: 'details',
                  attributes: { className: 'datatable' },
                  children: [
                    { kind: 'element', tag: 'summary', attributes: {}, children: ['Ver tabela de dados'] },
                    {
                      kind: 'element',
                      tag: 'div',
                      attributes: { className: 'tscroll' },
                      children: [
                        {
                          kind: 'element',
                          tag: 'table',
                          attributes: {},
                          children: [
                            {
                              kind: 'element',
                              tag: 'caption',
                              attributes: {},
                              children: ['Marcas dentro das prescrições de semaglutida (%)']
                            },
                            {
                              kind: 'element',
                              tag: 'thead',
                              attributes: {},
                              children: [
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['Mês'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['ago/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['set/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['out/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['nov/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['dez/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['jan/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['fev/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['mar/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['abr/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['mai/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['jun/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['jul/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['ago/26'] }
                                  ]
                                }
                              ]
                            },
                            {
                              kind: 'element',
                              tag: 'tbody',
                              attributes: {},
                              children: [
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    { kind: 'element', tag: 'th', attributes: { scope: 'row' }, children: ['Wegovy'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['94%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['93%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['92%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['88%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['87%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['87%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['89%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['89%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['87%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['83%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['59%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['38%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['39%'] }
                                  ]
                                },
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    { kind: 'element', tag: 'th', attributes: { scope: 'row' }, children: ['Ozivy'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['19%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['19%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['18%'] }
                                  ]
                                },
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    {
                                      kind: 'element',
                                      tag: 'th',
                                      attributes: { scope: 'row' },
                                      children: ['Poviztra']
                                    },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['<1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['<1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['<1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['3%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['3%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['11%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['8%'] }
                                  ]
                                },
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    { kind: 'element', tag: 'th', attributes: { scope: 'row' }, children: ['Semavy'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] }
                                  ]
                                },
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    { kind: 'element', tag: 'th', attributes: { scope: 'row' }, children: ['Ozempic'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['3%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['5%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['6%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['9%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['8%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['7%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['6%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['7%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['6%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['7%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['5%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['3%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] }
                                  ]
                                },
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    {
                                      kind: 'element',
                                      tag: 'th',
                                      attributes: { scope: 'row' },
                                      children: ['Semaglutida (marca não identificada)']
                                    },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['<1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['<1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['<1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['1%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['12%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['26%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['30%'] }
                                  ]
                                },
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    {
                                      kind: 'element',
                                      tag: 'th',
                                      attributes: { scope: 'row' },
                                      children: ['Rybelsus']
                                    },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['3%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['5%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['3%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['3%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['5%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['2%'] }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                '\n'
              ]
            },
            '\n'
          ]
        },
        '\n\n',
        {
          kind: 'element',
          tag: 'section',
          attributes: { id: 'inicio-continuidade', 'aria-labelledby': 'inicio-titulo' },
          children: [
            '\n',
            {
              kind: 'element',
              tag: 'h2',
              attributes: { id: 'inicio-titulo' },
              children: ['Quantas prescrições são de início e quantas de continuidade?']
            },
            '\n',
            {
              kind: 'element',
              tag: 'p',
              attributes: {},
              children: [
                'Em agosto de 2026, 71% das prescrições de GLP-1 da Medleve foram de acompanhamento de um tratamento já iniciado e 29% de início de tratamento. Em agosto de 2025, a continuidade representava 39%.'
              ]
            },
            '\n',
            {
              kind: 'element',
              tag: 'figure',
              attributes: {},
              children: [
                '\n',
                {
                  kind: 'element',
                  tag: 'figcaption',
                  attributes: {},
                  children: ['Início e continuidade de tratamento (% das prescrições de GLP-1)']
                },
                '\n',
                {
                  kind: 'chart',
                  file: 'grafico-inicio-2026-08.svg',
                  title: 'Início e continuidade de tratamento nas prescrições de GLP-1 da Medleve',
                  description: 'Continuidade passou de 39% para 71%.',
                  labels: [
                    '0%',
                    '20%',
                    '40%',
                    '60%',
                    '80%',
                    '100%',
                    'ago/25',
                    'set/25',
                    'out/25',
                    'nov/25',
                    'dez/25',
                    'jan/26',
                    'fev/26',
                    'mar/26',
                    'abr/26',
                    'mai/26',
                    'jun/26',
                    'jul/26',
                    'ago/26'
                  ],
                  width: 720,
                  height: 300
                },
                {
                  kind: 'element',
                  tag: 'ul',
                  attributes: { className: 'legend' },
                  children: [
                    {
                      kind: 'element',
                      tag: 'li',
                      attributes: {},
                      children: [
                        {
                          kind: 'element',
                          tag: 'span',
                          attributes: { className: 'sw', style: { background: 'rgb(63, 84, 128)' } },
                          children: []
                        },
                        'Continuidade'
                      ]
                    },
                    {
                      kind: 'element',
                      tag: 'li',
                      attributes: {},
                      children: [
                        {
                          kind: 'element',
                          tag: 'span',
                          attributes: { className: 'sw', style: { background: 'rgb(217, 169, 58)' } },
                          children: []
                        },
                        'Início'
                      ]
                    }
                  ]
                },
                '\n',
                {
                  kind: 'element',
                  tag: 'p',
                  attributes: { className: 'source' },
                  children: ['Fonte: Observatório Medleve de GLP-1, edição de agosto de 2026.']
                },
                '\n',
                {
                  kind: 'element',
                  tag: 'details',
                  attributes: { className: 'datatable' },
                  children: [
                    { kind: 'element', tag: 'summary', attributes: {}, children: ['Ver tabela de dados'] },
                    {
                      kind: 'element',
                      tag: 'div',
                      attributes: { className: 'tscroll' },
                      children: [
                        {
                          kind: 'element',
                          tag: 'table',
                          attributes: {},
                          children: [
                            {
                              kind: 'element',
                              tag: 'caption',
                              attributes: {},
                              children: ['Início e continuidade (% das prescrições de GLP-1)']
                            },
                            {
                              kind: 'element',
                              tag: 'thead',
                              attributes: {},
                              children: [
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['Mês'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['ago/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['set/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['out/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['nov/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['dez/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['jan/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['fev/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['mar/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['abr/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['mai/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['jun/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['jul/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['ago/26'] }
                                  ]
                                }
                              ]
                            },
                            {
                              kind: 'element',
                              tag: 'tbody',
                              attributes: {},
                              children: [
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    { kind: 'element', tag: 'th', attributes: { scope: 'row' }, children: ['Início'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['61%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['60%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['54%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['56%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['44%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['38%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['27%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['30%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['28%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['26%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['26%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['34%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['29%'] }
                                  ]
                                },
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    {
                                      kind: 'element',
                                      tag: 'th',
                                      attributes: { scope: 'row' },
                                      children: ['Continuidade']
                                    },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['39%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['40%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['46%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['44%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['56%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['62%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['73%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['70%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['72%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['74%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['74%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['66%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['71%'] }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                '\n'
              ]
            },
            '\n'
          ]
        },
        '\n\n',
        {
          kind: 'element',
          tag: 'section',
          attributes: { id: 'retorno', 'aria-labelledby': 'retorno-titulo' },
          children: [
            '\n',
            {
              kind: 'element',
              tag: 'h2',
              attributes: { id: 'retorno-titulo' },
              children: ['Quantos pacientes voltam para acompanhamento?']
            },
            '\n',
            {
              kind: 'element',
              tag: 'p',
              attributes: {},
              children: [
                'Entre os pacientes que fizeram a primeira consulta na Medleve em maio de 2026, 29% voltaram para uma nova consulta em até 90 dias. Em 180 dias, a taxa foi de 36% na coorte de fevereiro de 2026, a mais recente com seis meses completos de acompanhamento.'
              ]
            },
            '\n',
            {
              kind: 'element',
              tag: 'p',
              attributes: {},
              children: [
                'Entre quem voltou, o intervalo mediano entre a primeira e a segunda consulta foi de 57 dias na coorte de fevereiro de 2026: metade retornou entre 32 e 95 dias.'
              ]
            },
            '\n',
            {
              kind: 'element',
              tag: 'figure',
              attributes: {},
              children: [
                '\n',
                {
                  kind: 'element',
                  tag: 'figcaption',
                  attributes: {},
                  children: ['Taxa de retorno por mês da primeira consulta (%)']
                },
                '\n',
                {
                  kind: 'chart',
                  file: 'grafico-retorno-2026-08.svg',
                  title: 'Taxa de retorno em até 90 e 180 dias, por mês da primeira consulta',
                  description:
                    'Retorno em 90 dias: 29% na coorte de maio de 2026. Em 180 dias: 36% na coorte de fevereiro de 2026.',
                  labels: [
                    '0%',
                    '10%',
                    '20%',
                    '30%',
                    '40%',
                    '50%',
                    'ago/25',
                    'set/25',
                    'out/25',
                    'nov/25',
                    'dez/25',
                    'jan/26',
                    'fev/26',
                    'mar/26',
                    'abr/26',
                    'mai/26',
                    'jun/26',
                    'jul/26',
                    'ago/26'
                  ],
                  width: 720,
                  height: 300
                },
                {
                  kind: 'element',
                  tag: 'ul',
                  attributes: { className: 'legend' },
                  children: [
                    {
                      kind: 'element',
                      tag: 'li',
                      attributes: {},
                      children: [
                        {
                          kind: 'element',
                          tag: 'span',
                          attributes: { className: 'sw', style: { background: 'rgb(63, 84, 128)' } },
                          children: []
                        },
                        '90 dias'
                      ]
                    },
                    {
                      kind: 'element',
                      tag: 'li',
                      attributes: {},
                      children: [
                        {
                          kind: 'element',
                          tag: 'span',
                          attributes: { className: 'sw', style: { background: 'rgb(217, 169, 58)' } },
                          children: []
                        },
                        '180 dias'
                      ]
                    }
                  ]
                },
                '\n',
                {
                  kind: 'element',
                  tag: 'p',
                  attributes: { className: 'source' },
                  children: [
                    'Fonte: Observatório Medleve de GLP-1. Só são exibidas coortes com o período de acompanhamento completo.'
                  ]
                },
                '\n',
                {
                  kind: 'element',
                  tag: 'details',
                  attributes: { className: 'datatable' },
                  children: [
                    { kind: 'element', tag: 'summary', attributes: {}, children: ['Ver tabela de dados'] },
                    {
                      kind: 'element',
                      tag: 'div',
                      attributes: { className: 'tscroll' },
                      children: [
                        {
                          kind: 'element',
                          tag: 'table',
                          attributes: {},
                          children: [
                            {
                              kind: 'element',
                              tag: 'caption',
                              attributes: {},
                              children: ['Taxa de retorno por coorte da primeira consulta (%)']
                            },
                            {
                              kind: 'element',
                              tag: 'thead',
                              attributes: {},
                              children: [
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['Coorte'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['ago/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['set/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['out/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['nov/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['dez/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['jan/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['fev/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['mar/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['abr/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['mai/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['jun/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['jul/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['ago/26'] }
                                  ]
                                }
                              ]
                            },
                            {
                              kind: 'element',
                              tag: 'tbody',
                              attributes: {},
                              children: [
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    {
                                      kind: 'element',
                                      tag: 'th',
                                      attributes: { scope: 'row' },
                                      children: ['Em até 90 dias']
                                    },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['21%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['21%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['22%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['25%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['27%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['26%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['26%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['27%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['27%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['29%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] }
                                  ]
                                },
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    {
                                      kind: 'element',
                                      tag: 'th',
                                      attributes: { scope: 'row' },
                                      children: ['Em até 180 dias']
                                    },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['33%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['32%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['33%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['34%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['36%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['35%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['36%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                '\n'
              ]
            },
            '\n',
            {
              kind: 'element',
              tag: 'figure',
              attributes: {},
              children: [
                '\n',
                {
                  kind: 'element',
                  tag: 'figcaption',
                  attributes: {},
                  children: [
                    'Tempo até o primeiro retorno, coorte de fevereiro de 2026 (% de quem retornou em até 180 dias)'
                  ]
                },
                '\n',
                {
                  kind: 'chart',
                  file: 'grafico-tempo-retorno-2026-08.svg',
                  title: 'Tempo até o primeiro retorno, coorte de fevereiro de 2026',
                  description: 'Mediana de 57 dias.',
                  labels: ['0–30 dias', '22%', '31–60 dias', '32%', '61–90 dias', '19%', '91–180 dias', '27%'],
                  width: 720,
                  height: 146
                },
                '\n',
                {
                  kind: 'element',
                  tag: 'details',
                  attributes: { className: 'datatable' },
                  children: [
                    { kind: 'element', tag: 'summary', attributes: {}, children: ['Ver tabela de dados'] },
                    {
                      kind: 'element',
                      tag: 'div',
                      attributes: { className: 'tscroll' },
                      children: [
                        {
                          kind: 'element',
                          tag: 'table',
                          attributes: {},
                          children: [
                            {
                              kind: 'element',
                              tag: 'caption',
                              attributes: {},
                              children: ['Dias até o primeiro retorno, por coorte']
                            },
                            {
                              kind: 'element',
                              tag: 'thead',
                              attributes: {},
                              children: [
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['Coorte'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['ago/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['set/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['out/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['nov/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['dez/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['jan/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['fev/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['mar/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['abr/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['mai/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['jun/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['jul/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['ago/26'] }
                                  ]
                                }
                              ]
                            },
                            {
                              kind: 'element',
                              tag: 'tbody',
                              attributes: {},
                              children: [
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    { kind: 'element', tag: 'th', attributes: { scope: 'row' }, children: ['P25'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['50.0'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['44.0'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['38.0'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['31.0'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['31.0'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['30.0'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['32.0'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] }
                                  ]
                                },
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    { kind: 'element', tag: 'th', attributes: { scope: 'row' }, children: ['Mediana'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['73.0'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['69.0'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['65.0'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['55.0'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['52.0'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['55.0'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['57.0'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] }
                                  ]
                                },
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    { kind: 'element', tag: 'th', attributes: { scope: 'row' }, children: ['P75'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['106.0'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['108.0'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['104.0'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['91.0'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['89.0'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['94.0'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['95.0'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                '\n'
              ]
            },
            '\n'
          ]
        },
        '\n\n',
        {
          kind: 'element',
          tag: 'section',
          attributes: { id: 'trocas', 'aria-labelledby': 'trocas-titulo' },
          children: [
            '\n',
            {
              kind: 'element',
              tag: 'h2',
              attributes: { id: 'trocas-titulo' },
              children: ['Com que frequência os pacientes trocam de medicamento?']
            },
            '\n',
            {
              kind: 'element',
              tag: 'p',
              attributes: {},
              children: [
                'Em agosto de 2026, 17% das prescrições de retorno na Medleve tiveram marca ou molécula diferente da prescrição anterior do mesmo paciente. Entre essas trocas, 62% foram entre semaglutida e tirzepatida.'
              ]
            },
            '\n',
            {
              kind: 'element',
              tag: 'p',
              attributes: {},
              children: [
                'No período de agosto de 2025 a agosto de 2026, 24% dos pacientes com pelo menos duas prescrições tiveram alguma mudança de medicamento, e 82% permaneceram na mesma molécula.'
              ]
            },
            '\n',
            {
              kind: 'element',
              tag: 'figure',
              attributes: {},
              children: [
                '\n',
                {
                  kind: 'element',
                  tag: 'figcaption',
                  attributes: {},
                  children: ['Trocas de medicamento nas prescrições de retorno (%)']
                },
                '\n',
                {
                  kind: 'chart',
                  file: 'grafico-trocas-2026-08.svg',
                  title: 'Trocas de medicamento nas prescrições de retorno',
                  description: '17% das prescrições de retorno em agosto de 2026 tiveram marca ou molécula diferente.',
                  labels: [
                    '0%',
                    '20%',
                    '40%',
                    '60%',
                    '80%',
                    '100%',
                    'ago/25',
                    'set/25',
                    'out/25',
                    'nov/25',
                    'dez/25',
                    'jan/26',
                    'fev/26',
                    'mar/26',
                    'abr/26',
                    'mai/26',
                    'jun/26',
                    'jul/26',
                    'ago/26'
                  ],
                  width: 720,
                  height: 300
                },
                {
                  kind: 'element',
                  tag: 'ul',
                  attributes: { className: 'legend' },
                  children: [
                    {
                      kind: 'element',
                      tag: 'li',
                      attributes: {},
                      children: [
                        {
                          kind: 'element',
                          tag: 'span',
                          attributes: { className: 'sw', style: { background: 'rgb(192, 86, 122)' } },
                          children: []
                        },
                        'Trocas'
                      ]
                    },
                    {
                      kind: 'element',
                      tag: 'li',
                      attributes: {},
                      children: [
                        {
                          kind: 'element',
                          tag: 'span',
                          attributes: { className: 'sw', style: { background: 'rgb(63, 84, 128)' } },
                          children: []
                        },
                        'Entre moléculas'
                      ]
                    }
                  ]
                },
                '\n',
                {
                  kind: 'element',
                  tag: 'p',
                  attributes: { className: 'source' },
                  children: [
                    '"Trocas" = % das prescrições de retorno com marca ou molécula diferente. "Entre moléculas" = % das trocas que foram entre semaglutida e tirzepatida.'
                  ]
                },
                '\n',
                {
                  kind: 'element',
                  tag: 'details',
                  attributes: { className: 'datatable' },
                  children: [
                    { kind: 'element', tag: 'summary', attributes: {}, children: ['Ver tabela de dados'] },
                    {
                      kind: 'element',
                      tag: 'div',
                      attributes: { className: 'tscroll' },
                      children: [
                        {
                          kind: 'element',
                          tag: 'table',
                          attributes: {},
                          children: [
                            {
                              kind: 'element',
                              tag: 'caption',
                              attributes: {},
                              children: ['Trocas de medicamento (%)']
                            },
                            {
                              kind: 'element',
                              tag: 'thead',
                              attributes: {},
                              children: [
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['Mês'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['ago/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['set/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['out/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['nov/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['dez/25'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['jan/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['fev/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['mar/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['abr/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['mai/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['jun/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['jul/26'] },
                                    { kind: 'element', tag: 'th', attributes: { scope: 'col' }, children: ['ago/26'] }
                                  ]
                                }
                              ]
                            },
                            {
                              kind: 'element',
                              tag: 'tbody',
                              attributes: {},
                              children: [
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    {
                                      kind: 'element',
                                      tag: 'th',
                                      attributes: { scope: 'row' },
                                      children: ['Trocas (% das prescrições de retorno)']
                                    },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['20%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['21%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['17%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['13%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['12%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['12%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['12%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['12%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['13%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['17%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['21%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['17%'] }
                                  ]
                                },
                                {
                                  kind: 'element',
                                  tag: 'tr',
                                  attributes: {},
                                  children: [
                                    {
                                      kind: 'element',
                                      tag: 'th',
                                      attributes: { scope: 'row' },
                                      children: ['Entre semaglutida e tirzepatida (% das trocas)']
                                    },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['—'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['82%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['85%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['85%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['82%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['82%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['84%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['84%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['64%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['57%'] },
                                    { kind: 'element', tag: 'td', attributes: {}, children: ['62%'] }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                '\n'
              ]
            },
            '\n',
            {
              kind: 'element',
              tag: 'aside',
              attributes: {
                className: 'ml-callout ml-callout--info',
                id: 'bom-saber',
                role: 'note',
                'aria-labelledby': 'bom-saber-titulo'
              },
              children: [
                '\n',
                {
                  kind: 'element',
                  tag: 'h3',
                  attributes: { id: 'bom-saber-titulo', className: 'ml-callout__title' },
                  children: ['Bom saber']
                },
                '\n',
                {
                  kind: 'element',
                  tag: 'p',
                  attributes: {},
                  children: [
                    'Uma troca de medicamento não significa que o anterior falhou. Ela pode refletir preço, disponibilidade, tolerância ou ajuste do tratamento, decididos entre médico e paciente.'
                  ]
                },
                '\n'
              ]
            },
            '\n'
          ]
        },
        '\n\n',
        {
          kind: 'element',
          tag: 'section',
          attributes: { id: 'metodologia', 'aria-labelledby': 'metodo-titulo' },
          children: [
            '\n',
            { kind: 'element', tag: 'h2', attributes: { id: 'metodo-titulo' }, children: ['Metodologia'] },
            '\n',
            {
              kind: 'element',
              tag: 'dl',
              attributes: { className: 'method' },
              children: [
                '\n',
                { kind: 'element', tag: 'dt', attributes: {}, children: ['Fonte'] },
                {
                  kind: 'element',
                  tag: 'dd',
                  attributes: {},
                  children: [
                    'Consultas de emagrecimento realizadas na plataforma Medleve (status finalizada ou iniciada).'
                  ]
                },
                '\n',
                { kind: 'element', tag: 'dt', attributes: {}, children: ['Prescrição válida'] },
                {
                  kind: 'element',
                  tag: 'dd',
                  attributes: {},
                  children: [
                    'Prescrição de medicamento agonista de GLP-1 em consulta realizada. Prescrições canceladas são excluídas. Uma prescrição por paciente por dia.'
                  ]
                },
                '\n',
                { kind: 'element', tag: 'dt', attributes: {}, children: ['Molécula e marca'] },
                {
                  kind: 'element',
                  tag: 'dd',
                  attributes: {},
                  children: [
                    'Semaglutida inclui Wegovy, Ozempic, Rybelsus, Ozivy, Poviztra, Semavy e semaglutida sem marca informada. Tirzepatida inclui Mounjaro e tirzepatida sem marca informada. "Outras" inclui liraglutida.'
                  ]
                },
                '\n',
                { kind: 'element', tag: 'dt', attributes: {}, children: ['Início e continuidade'] },
                {
                  kind: 'element',
                  tag: 'dd',
                  attributes: {},
                  children: [
                    'Início = prescrição em consulta inicial; continuidade = prescrição em consulta de retorno.'
                  ]
                },
                '\n',
                { kind: 'element', tag: 'dt', attributes: {}, children: ['Taxa de retorno'] },
                {
                  kind: 'element',
                  tag: 'dd',
                  attributes: {},
                  children: [
                    'Pacientes com nova consulta realizada em até 90 (ou 180) dias da primeira consulta ÷ pacientes da coorte do mês. Só coortes com o período completo.'
                  ]
                },
                '\n',
                { kind: 'element', tag: 'dt', attributes: {}, children: ['Troca de medicamento'] },
                {
                  kind: 'element',
                  tag: 'dd',
                  attributes: {},
                  children: [
                    'Prescrição de retorno com marca ou molécula diferente da prescrição anterior do mesmo paciente. Trocas entre marcas só contam quando as duas marcas são identificadas.'
                  ]
                },
                '\n',
                { kind: 'element', tag: 'dt', attributes: {}, children: ['Publicação'] },
                {
                  kind: 'element',
                  tag: 'dd',
                  attributes: {},
                  children: [
                    'Percentuais arredondados para inteiro (podem não somar 100%). Base mínima de 100 por indicador; abaixo disso, o valor não é publicado ("—"). Defasagem de um mês. Série a partir de agosto de 2025.'
                  ]
                },
                '\n',
                { kind: 'element', tag: 'dt', attributes: {}, children: ['Privacidade'] },
                {
                  kind: 'element',
                  tag: 'dd',
                  attributes: {},
                  children: [
                    'Apenas dados agregados e anonimizados. Números absolutos de pacientes e prescrições não são divulgados.'
                  ]
                },
                '\n'
              ]
            },
            '\n',
            { kind: 'element', tag: 'h3', attributes: {}, children: ['Limitações'] },
            '\n',
            {
              kind: 'element',
              tag: 'p',
              attributes: {},
              children: [
                'Os dados refletem apenas as prescrições feitas na Medleve, uma plataforma de telemedicina, e não representam o mercado brasileiro nem a população geral. São dados observacionais: não indicam causa, eficácia ou superioridade de nenhum medicamento, e não constituem recomendação médica.'
              ]
            },
            '\n'
          ]
        },
        '\n\n',
        {
          kind: 'element',
          tag: 'section',
          attributes: { id: 'dados-abertos', 'aria-labelledby': 'download-titulo' },
          children: [
            '\n',
            {
              kind: 'element',
              tag: 'h2',
              attributes: { id: 'download-titulo' },
              children: ['Baixar os dados e citar']
            },
            '\n',
            {
              kind: 'element',
              tag: 'p',
              attributes: {},
              children: [
                'Os dados desta edição estão disponíveis sob licença ',
                {
                  kind: 'element',
                  tag: 'a',
                  attributes: { href: 'https://creativecommons.org/licenses/by/4.0/deed.pt-br' },
                  children: ['CC BY 4.0']
                },
                ': podem ser reutilizados com atribuição.'
              ]
            },
            '\n',
            {
              kind: 'element',
              tag: 'div',
              attributes: { className: 'downloads' },
              children: [
                {
                  kind: 'element',
                  tag: 'a',
                  attributes: {
                    className: 'btn',
                    href: 'https://www.medleve.com/dados/glp-1/observatorio-glp1-2026-08.csv',
                    download: true
                  },
                  children: ['Baixar CSV']
                },
                {
                  kind: 'element',
                  tag: 'a',
                  attributes: {
                    className: 'btn btn--ghost',
                    href: 'https://www.medleve.com/dados/glp-1/observatorio-glp1-2026-08.json',
                    download: true
                  },
                  children: ['Baixar JSON']
                }
              ]
            },
            '\n',
            { kind: 'element', tag: 'h3', attributes: {}, children: ['Como citar'] },
            '\n',
            {
              kind: 'element',
              tag: 'p',
              attributes: { className: 'cite', id: 'como-citar' },
              children: [
                'Medleve. Observatório Medleve de GLP-1 — edição de agosto de 2026. Disponível em: https://www.medleve.com/dados/glp-1/2026-08. Acesso em: [data].'
              ]
            },
            '\n'
          ]
        },
        '\n\n',
        {
          kind: 'element',
          tag: 'section',
          attributes: { id: 'imprensa', 'aria-labelledby': 'imprensa-titulo' },
          children: [
            '\n',
            {
              kind: 'element',
              tag: 'h2',
              attributes: { id: 'imprensa-titulo' },
              children: ['Para imprensa e pesquisadores']
            },
            '\n',
            {
              kind: 'element',
              tag: 'p',
              attributes: {},
              children: [
                'Os gráficos desta edição podem ser reproduzidos com a fonte "Observatório Medleve de GLP-1" e link para esta página.'
              ]
            },
            '\n',
            {
              kind: 'element',
              tag: 'ul',
              attributes: { className: 'press' },
              children: [
                '\n',
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: {},
                  children: [
                    {
                      kind: 'element',
                      tag: 'a',
                      attributes: { href: '/dados/glp-1/grafico-molecula-2026-08.svg', download: true },
                      children: ['Gráfico: participação por molécula (SVG)']
                    }
                  ]
                },
                '\n',
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: {},
                  children: [
                    {
                      kind: 'element',
                      tag: 'a',
                      attributes: { href: '/dados/glp-1/grafico-marca-2026-08.svg', download: true },
                      children: ['Gráfico: participação por marca (SVG)']
                    }
                  ]
                },
                '\n',
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: {},
                  children: [
                    {
                      kind: 'element',
                      tag: 'a',
                      attributes: { href: '/dados/glp-1/grafico-semaglutida-2026-08.svg', download: true },
                      children: ['Gráfico: marcas de semaglutida (SVG)']
                    }
                  ]
                },
                '\n',
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: {},
                  children: [
                    {
                      kind: 'element',
                      tag: 'a',
                      attributes: { href: '/dados/glp-1/grafico-inicio-2026-08.svg', download: true },
                      children: ['Gráfico: início e continuidade (SVG)']
                    }
                  ]
                },
                '\n',
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: {},
                  children: [
                    {
                      kind: 'element',
                      tag: 'a',
                      attributes: { href: '/dados/glp-1/grafico-retorno-2026-08.svg', download: true },
                      children: ['Gráfico: taxa de retorno (SVG)']
                    }
                  ]
                },
                '\n',
                {
                  kind: 'element',
                  tag: 'li',
                  attributes: {},
                  children: [
                    {
                      kind: 'element',
                      tag: 'a',
                      attributes: { href: '/dados/glp-1/grafico-trocas-2026-08.svg', download: true },
                      children: ['Gráfico: trocas de medicamento (SVG)']
                    }
                  ]
                },
                '\n'
              ]
            },
            '\n',
            {
              kind: 'element',
              tag: 'p',
              attributes: {},
              children: [
                'Para entrevistas, dados adicionais ou comentários do Dr. Carlos Seraphim: ',
                {
                  kind: 'element',
                  tag: 'a',
                  attributes: { href: 'mailto:contato@medleve.com' },
                  children: ['contato@medleve.com']
                },
                '.'
              ]
            },
            '\n'
          ]
        },
        '\n\n',
        {
          kind: 'element',
          tag: 'section',
          attributes: { id: 'edicoes', 'aria-labelledby': 'edicoes-titulo' },
          children: [
            '\n',
            { kind: 'element', tag: 'h2', attributes: { id: 'edicoes-titulo' }, children: ['Edições anteriores'] },
            '\n',
            { kind: 'editions' },
            '\n'
          ]
        },
        '\n\n',
        { kind: 'cta', variant: 'full', position: 2, support: '' },
        '\n\n',
        {
          kind: 'element',
          tag: 'section',
          attributes: { className: 'ml-faq', id: 'perguntas-frequentes', 'aria-labelledby': 'faq-titulo' },
          children: [
            '\n',
            { kind: 'element', tag: 'h2', attributes: { id: 'faq-titulo' }, children: ['Perguntas frequentes'] },
            '\n',
            {
              kind: 'element',
              tag: 'details',
              attributes: { className: 'ml-faq__item', id: 'faq-1', open: true },
              children: [
                {
                  kind: 'element',
                  tag: 'summary',
                  attributes: {},
                  children: [
                    {
                      kind: 'element',
                      tag: 'h3',
                      attributes: { className: 'ml-faq__q' },
                      children: ['O que é o Observatório Medleve de GLP-1?']
                    }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'div',
                  attributes: { className: 'ml-faq__a' },
                  children: [
                    {
                      kind: 'element',
                      tag: 'p',
                      attributes: {},
                      children: [
                        'É uma publicação mensal com indicadores das prescrições de medicamentos GLP-1, como semaglutida e tirzepatida, feitas por médicos na plataforma Medleve. A edição atual traz dados até agosto de 2026.'
                      ]
                    }
                  ]
                }
              ]
            },
            {
              kind: 'element',
              tag: 'details',
              attributes: { className: 'ml-faq__item', id: 'faq-2' },
              children: [
                {
                  kind: 'element',
                  tag: 'summary',
                  attributes: {},
                  children: [
                    {
                      kind: 'element',
                      tag: 'h3',
                      attributes: { className: 'ml-faq__q' },
                      children: ['De onde vêm os dados?']
                    }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'div',
                  attributes: { className: 'ml-faq__a' },
                  children: [
                    {
                      kind: 'element',
                      tag: 'p',
                      attributes: {},
                      children: [
                        'Das consultas realizadas na plataforma Medleve, com consultas finalizadas ou iniciadas. Prescrições canceladas são excluídas e cada paciente conta uma vez por dia.'
                      ]
                    }
                  ]
                }
              ]
            },
            {
              kind: 'element',
              tag: 'details',
              attributes: { className: 'ml-faq__item', id: 'faq-3' },
              children: [
                {
                  kind: 'element',
                  tag: 'summary',
                  attributes: {},
                  children: [
                    {
                      kind: 'element',
                      tag: 'h3',
                      attributes: { className: 'ml-faq__q' },
                      children: ['Os dados representam o mercado brasileiro?']
                    }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'div',
                  attributes: { className: 'ml-faq__a' },
                  children: [
                    {
                      kind: 'element',
                      tag: 'p',
                      attributes: {},
                      children: [
                        'Não. São prescrições observadas na Medleve, uma plataforma de telemedicina. Não devem ser lidos como participação de mercado no Brasil.'
                      ]
                    }
                  ]
                }
              ]
            },
            {
              kind: 'element',
              tag: 'details',
              attributes: { className: 'ml-faq__item', id: 'faq-4' },
              children: [
                {
                  kind: 'element',
                  tag: 'summary',
                  attributes: {},
                  children: [
                    {
                      kind: 'element',
                      tag: 'h3',
                      attributes: { className: 'ml-faq__q' },
                      children: ['Os dados são anonimizados?']
                    }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'div',
                  attributes: { className: 'ml-faq__a' },
                  children: [
                    {
                      kind: 'element',
                      tag: 'p',
                      attributes: {},
                      children: [
                        'Sim. A página publica apenas percentuais agregados e arredondados, sem nenhuma informação que identifique pacientes ou médicos.'
                      ]
                    }
                  ]
                }
              ]
            },
            {
              kind: 'element',
              tag: 'details',
              attributes: { className: 'ml-faq__item', id: 'faq-5' },
              children: [
                {
                  kind: 'element',
                  tag: 'summary',
                  attributes: {},
                  children: [
                    {
                      kind: 'element',
                      tag: 'h3',
                      attributes: { className: 'ml-faq__q' },
                      children: ['A Medleve divulga o número de pacientes ou de prescrições?']
                    }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'div',
                  attributes: { className: 'ml-faq__a' },
                  children: [
                    {
                      kind: 'element',
                      tag: 'p',
                      attributes: {},
                      children: [
                        'Não. O observatório publica apenas percentuais e índices. Números absolutos não são divulgados.'
                      ]
                    }
                  ]
                }
              ]
            },
            {
              kind: 'element',
              tag: 'details',
              attributes: { className: 'ml-faq__item', id: 'faq-6' },
              children: [
                {
                  kind: 'element',
                  tag: 'summary',
                  attributes: {},
                  children: [
                    {
                      kind: 'element',
                      tag: 'h3',
                      attributes: { className: 'ml-faq__q' },
                      children: ['Com que frequência os dados são atualizados?']
                    }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'div',
                  attributes: { className: 'ml-faq__a' },
                  children: [
                    {
                      kind: 'element',
                      tag: 'p',
                      attributes: {},
                      children: [
                        'Todo mês, com um mês de defasagem. Cada edição fica arquivada em um endereço permanente.'
                      ]
                    }
                  ]
                }
              ]
            },
            {
              kind: 'element',
              tag: 'details',
              attributes: { className: 'ml-faq__item', id: 'faq-7' },
              children: [
                {
                  kind: 'element',
                  tag: 'summary',
                  attributes: {},
                  children: [
                    {
                      kind: 'element',
                      tag: 'h3',
                      attributes: { className: 'ml-faq__q' },
                      children: ['O que significa participação nas prescrições?']
                    }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'div',
                  attributes: { className: 'ml-faq__a' },
                  children: [
                    {
                      kind: 'element',
                      tag: 'p',
                      attributes: {},
                      children: [
                        'É a porcentagem das prescrições de GLP-1 do mês que corresponde a uma molécula ou marca. Por exemplo, 51% de tirzepatida significa que 51 de cada 100 prescrições de GLP-1 da Medleve no mês foram de tirzepatida.'
                      ]
                    }
                  ]
                }
              ]
            },
            {
              kind: 'element',
              tag: 'details',
              attributes: { className: 'ml-faq__item', id: 'faq-8' },
              children: [
                {
                  kind: 'element',
                  tag: 'summary',
                  attributes: {},
                  children: [
                    {
                      kind: 'element',
                      tag: 'h3',
                      attributes: { className: 'ml-faq__q' },
                      children: ['Os dados podem ser usados como recomendação médica?']
                    }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'div',
                  attributes: { className: 'ml-faq__a' },
                  children: [
                    {
                      kind: 'element',
                      tag: 'p',
                      attributes: {},
                      children: [
                        'Não. São dados observacionais de prescrição. A escolha de um tratamento depende de avaliação médica individual.'
                      ]
                    }
                  ]
                }
              ]
            },
            {
              kind: 'element',
              tag: 'details',
              attributes: { className: 'ml-faq__item', id: 'faq-9' },
              children: [
                {
                  kind: 'element',
                  tag: 'summary',
                  attributes: {},
                  children: [
                    {
                      kind: 'element',
                      tag: 'h3',
                      attributes: { className: 'ml-faq__q' },
                      children: ['Posso citar ou reutilizar os dados?']
                    }
                  ]
                },
                {
                  kind: 'element',
                  tag: 'div',
                  attributes: { className: 'ml-faq__a' },
                  children: [
                    {
                      kind: 'element',
                      tag: 'p',
                      attributes: {},
                      children: [
                        'Sim, com atribuição: "Medleve. Observatório Medleve de GLP-1 — edição de agosto de 2026. Disponível em: https://www.medleve.com/dados/glp-1/2026-08. Acesso em: [data]." Os dados estão disponíveis para download em CSV e JSON.'
                      ]
                    }
                  ]
                }
              ]
            },
            '\n'
          ]
        },
        '\n\n',
        {
          kind: 'element',
          tag: 'footer',
          attributes: {},
          children: [
            '\n',
            {
              kind: 'element',
              tag: 'p',
              attributes: { className: 'meta' },
              children: [
                {
                  kind: 'element',
                  tag: 'span',
                  attributes: {},
                  children: [
                    'Por ',
                    {
                      kind: 'element',
                      tag: 'a',
                      attributes: { href: '/equipe-medica/carlos-seraphim' },
                      children: ['Dr. Carlos Seraphim']
                    },
                    ', endocrinologista — CRM-SP 156663'
                  ]
                },
                {
                  kind: 'element',
                  tag: 'span',
                  attributes: {},
                  children: ['Última atualização: {{data_de_publicacao}}']
                }
              ]
            },
            '\n',
            {
              kind: 'element',
              tag: 'p',
              attributes: { className: 'source' },
              children: [
                'Dados observacionais de prescrições na plataforma Medleve. Não representam o mercado brasileiro nem constituem recomendação médica.'
              ]
            },
            '\n'
          ]
        },
        '\n'
      ]
    },
    '\n'
  ],
  graph: {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': 'https://www.medleve.com/#organization',
        name: 'Medleve',
        url: 'https://www.medleve.com/',
        logo: 'https://www.medleve.com/landings/medleve/medleve-logo.png',
        description:
          'Plataforma brasileira de saúde digital que conecta pacientes a médicos para avaliação e acompanhamento de tratamentos para obesidade, sobrepeso e saúde metabólica.',
        areaServed: { '@type': 'Country', name: 'Brasil' },
        knowsAbout: ['GLP-1', 'semaglutida', 'tirzepatida', 'obesidade', 'telemedicina'],
        sameAs: [
          'https://www.instagram.com/medleve.br/',
          'https://www.linkedin.com/company/medlevebr',
          'https://youtube.com/@medlevebrasil',
          'https://www.facebook.com/profile.php?id=61577974430530',
          'https://www.tiktok.com/@medleve.br'
        ]
      },
      {
        '@type': 'WebSite',
        '@id': 'https://www.medleve.com/#website',
        url: 'https://www.medleve.com/',
        name: 'Medleve',
        publisher: { '@id': 'https://www.medleve.com/#organization' },
        inLanguage: 'pt-BR'
      },
      {
        '@type': ['WebPage', 'MedicalWebPage'],
        '@id': 'https://www.medleve.com/dados#webpage',
        url: 'https://www.medleve.com/dados',
        name: 'Observatório Medleve de GLP-1 — dados de agosto de 2026',
        inLanguage: 'pt-BR',
        abstract:
          'Em agosto de 2026, a tirzepatida (Mounjaro) representou 51% das prescrições de GLP-1 observadas na Medleve, e a semaglutida, 49%. Mounjaro foi o medicamento mais prescrito (51%), seguido de Wegovy (19%), Ozivy (9%) e Poviztra (4%). 71% das prescrições foram de acompanhamento de tratamento já iniciado. Os dados são da plataforma Medleve e não representam o mercado brasileiro.',
        isPartOf: { '@id': 'https://www.medleve.com/#website' },
        publisher: { '@id': 'https://www.medleve.com/#organization' },
        author: { '@id': 'https://www.medleve.com/equipe-medica/carlos-seraphim#person' },
        reviewedBy: { '@id': 'https://www.medleve.com/equipe-medica/carlos-seraphim#person' },
        datePublished: '{{data_de_publicacao_da_1a_edicao}}',
        dateModified: '{{data_de_publicacao}}',
        lastReviewed: '{{data_de_publicacao}}',
        mainEntity: { '@id': 'https://www.medleve.com/dados/glp-1/2026-08#dataset' },
        hasPart: [
          { '@id': 'https://www.medleve.com/dados/glp-1/2026-08#relatorio' },
          { '@id': 'https://www.medleve.com/dados#faq' }
        ],
        breadcrumb: { '@id': 'https://www.medleve.com/dados#breadcrumb' },
        about: [
          { '@id': 'https://www.medleve.com/semaglutida#entity' },
          { '@id': 'https://www.medleve.com/tirzepatida#entity' }
        ],
        speakable: {
          '@type': 'SpeakableSpecification',
          cssSelector: ['#resumo .ml-summary__answer', '#destaques .kpi__txt']
        }
      },
      {
        '@type': 'DataCatalog',
        '@id': 'https://www.medleve.com/dados#catalogo',
        name: 'Observatório Medleve de GLP-1',
        url: 'https://www.medleve.com/dados',
        publisher: { '@id': 'https://www.medleve.com/#organization' },
        inLanguage: 'pt-BR',
        dataset: [{ '@id': 'https://www.medleve.com/dados/glp-1/2026-08#dataset' }]
      },
      {
        '@type': 'Dataset',
        '@id': 'https://www.medleve.com/dados/glp-1/2026-08#dataset',
        name: 'Observatório Medleve de GLP-1 — prescrições de semaglutida e tirzepatida, edição de agosto de 2026',
        description:
          'Indicadores mensais agregados das prescrições de medicamentos agonistas de GLP-1 (semaglutida, tirzepatida e outros) feitas na plataforma de telemedicina Medleve no Brasil, de agosto de 2025 a agosto de 2026: participação por molécula e por marca, início e continuidade de tratamento, taxa de retorno e trocas de medicamento. Percentuais arredondados; não representa o mercado brasileiro.',
        url: 'https://www.medleve.com/dados/glp-1/2026-08',
        sameAs: 'https://www.medleve.com/dados',
        version: '2026-08',
        identifier: 'medleve-observatorio-glp1-2026-08',
        about: [
          { '@id': 'https://www.medleve.com/semaglutida#entity' },
          { '@id': 'https://www.medleve.com/tirzepatida#entity' }
        ],
        usageInfo: 'https://www.medleve.com/dados#metodologia',
        creditText:
          'Medleve. Observatório Medleve de GLP-1 — edição de agosto de 2026. Disponível em: https://www.medleve.com/dados/glp-1/2026-08. Acesso em: [data].',
        copyrightHolder: { '@id': 'https://www.medleve.com/#organization' },
        creator: { '@id': 'https://www.medleve.com/#organization' },
        publisher: { '@id': 'https://www.medleve.com/#organization' },
        author: { '@id': 'https://www.medleve.com/equipe-medica/carlos-seraphim#person' },
        includedInDataCatalog: { '@id': 'https://www.medleve.com/dados#catalogo' },
        inLanguage: 'pt-BR',
        isAccessibleForFree: true,
        license: 'https://creativecommons.org/licenses/by/4.0/deed.pt-br',
        temporalCoverage: '2025-08/2026-08',
        spatialCoverage: { '@type': 'Place', name: 'Brasil' },
        datePublished: '{{data_de_publicacao}}',
        dateModified: '{{data_de_publicacao}}',
        keywords: [
          'GLP-1',
          'semaglutida',
          'tirzepatida',
          'Mounjaro',
          'Wegovy',
          'Ozivy',
          'Poviztra',
          'Ozempic',
          'prescrições',
          'telemedicina',
          'obesidade',
          'Brasil'
        ],
        measurementTechnique:
          'Agregação de prescrições válidas em consultas finalizadas ou iniciadas na plataforma Medleve; uma prescrição por paciente por dia; percentuais arredondados para inteiro; base mínima de 100 por indicador.',
        variableMeasured: [
          {
            '@type': 'PropertyValue',
            name: 'Participação por molécula',
            description: 'Prescrições de GLP-1 do mês da molécula ÷ total de prescrições de GLP-1 do mês',
            unitText: '%'
          },
          {
            '@type': 'PropertyValue',
            name: 'Participação por marca',
            description: 'Prescrições de GLP-1 do mês da marca ÷ total de prescrições de GLP-1 do mês',
            unitText: '%'
          },
          {
            '@type': 'PropertyValue',
            name: 'Marcas dentro da semaglutida',
            description: 'Prescrições da marca ÷ prescrições de semaglutida no mês',
            unitText: '%'
          },
          {
            '@type': 'PropertyValue',
            name: 'Início e continuidade',
            description: 'Prescrições em consulta inicial ÷ total de prescrições',
            unitText: '%'
          },
          {
            '@type': 'PropertyValue',
            name: 'Taxa de retorno em 90 e 180 dias',
            description: 'Pacientes com nova consulta em até 90 ou 180 dias da primeira ÷ pacientes da coorte',
            unitText: '%'
          },
          {
            '@type': 'PropertyValue',
            name: 'Dias até o primeiro retorno',
            description: 'Mediana, P25 e P75 de dias entre a primeira e a segunda consulta',
            unitText: 'dias'
          },
          {
            '@type': 'PropertyValue',
            name: 'Taxa de troca de medicamento',
            description:
              'Prescrições de retorno com marca ou molécula diferente da anterior ÷ prescrições de retorno com prescrição anterior',
            unitText: '%'
          }
        ],
        distribution: [
          {
            '@type': 'DataDownload',
            encodingFormat: 'text/csv',
            contentUrl: 'https://www.medleve.com/dados/glp-1/observatorio-glp1-2026-08.csv'
          },
          {
            '@type': 'DataDownload',
            encodingFormat: 'application/json',
            contentUrl: 'https://www.medleve.com/dados/glp-1/observatorio-glp1-2026-08.json'
          }
        ],
        citation:
          'Medleve. Observatório Medleve de GLP-1 — edição de agosto de 2026. Disponível em: https://www.medleve.com/dados/glp-1/2026-08. Acesso em: [data].'
      },
      {
        '@type': 'Person',
        '@id': 'https://www.medleve.com/equipe-medica/carlos-seraphim#person',
        name: 'Carlos Eduardo Seraphim',
        honorificPrefix: 'Dr.',
        jobTitle: 'Médico endocrinologista',
        url: 'https://www.medleve.com/equipe-medica/carlos-seraphim',
        identifier: { '@type': 'PropertyValue', propertyID: 'CRM-SP', value: '156663' },
        worksFor: { '@id': 'https://www.medleve.com/#organization' }
      },
      {
        '@type': 'FAQPage',
        '@id': 'https://www.medleve.com/dados#faq',
        url: 'https://www.medleve.com/dados#perguntas-frequentes',
        inLanguage: 'pt-BR',
        isPartOf: { '@id': 'https://www.medleve.com/dados#webpage' },
        author: { '@id': 'https://www.medleve.com/equipe-medica/carlos-seraphim#person' },
        reviewedBy: { '@id': 'https://www.medleve.com/equipe-medica/carlos-seraphim#person' },
        mainEntity: [
          {
            '@type': 'Question',
            '@id': 'https://www.medleve.com/dados#faq-1',
            url: 'https://www.medleve.com/dados#faq-1',
            position: 1,
            name: 'O que é o Observatório Medleve de GLP-1?',
            acceptedAnswer: {
              '@type': 'Answer',
              '@id': 'https://www.medleve.com/dados#faq-1-resposta',
              text: 'É uma publicação mensal com indicadores das prescrições de medicamentos GLP-1, como semaglutida e tirzepatida, feitas por médicos na plataforma Medleve. A edição atual traz dados até agosto de 2026.',
              author: { '@id': 'https://www.medleve.com/equipe-medica/carlos-seraphim#person' }
            }
          },
          {
            '@type': 'Question',
            '@id': 'https://www.medleve.com/dados#faq-2',
            url: 'https://www.medleve.com/dados#faq-2',
            position: 2,
            name: 'De onde vêm os dados?',
            acceptedAnswer: {
              '@type': 'Answer',
              '@id': 'https://www.medleve.com/dados#faq-2-resposta',
              text: 'Das consultas realizadas na plataforma Medleve, com consultas finalizadas ou iniciadas. Prescrições canceladas são excluídas e cada paciente conta uma vez por dia.',
              author: { '@id': 'https://www.medleve.com/equipe-medica/carlos-seraphim#person' }
            }
          },
          {
            '@type': 'Question',
            '@id': 'https://www.medleve.com/dados#faq-3',
            url: 'https://www.medleve.com/dados#faq-3',
            position: 3,
            name: 'Os dados representam o mercado brasileiro?',
            acceptedAnswer: {
              '@type': 'Answer',
              '@id': 'https://www.medleve.com/dados#faq-3-resposta',
              text: 'Não. São prescrições observadas na Medleve, uma plataforma de telemedicina. Não devem ser lidos como participação de mercado no Brasil.',
              author: { '@id': 'https://www.medleve.com/equipe-medica/carlos-seraphim#person' }
            }
          },
          {
            '@type': 'Question',
            '@id': 'https://www.medleve.com/dados#faq-4',
            url: 'https://www.medleve.com/dados#faq-4',
            position: 4,
            name: 'Os dados são anonimizados?',
            acceptedAnswer: {
              '@type': 'Answer',
              '@id': 'https://www.medleve.com/dados#faq-4-resposta',
              text: 'Sim. A página publica apenas percentuais agregados e arredondados, sem nenhuma informação que identifique pacientes ou médicos.',
              author: { '@id': 'https://www.medleve.com/equipe-medica/carlos-seraphim#person' }
            }
          },
          {
            '@type': 'Question',
            '@id': 'https://www.medleve.com/dados#faq-5',
            url: 'https://www.medleve.com/dados#faq-5',
            position: 5,
            name: 'A Medleve divulga o número de pacientes ou de prescrições?',
            acceptedAnswer: {
              '@type': 'Answer',
              '@id': 'https://www.medleve.com/dados#faq-5-resposta',
              text: 'Não. O observatório publica apenas percentuais e índices. Números absolutos não são divulgados.',
              author: { '@id': 'https://www.medleve.com/equipe-medica/carlos-seraphim#person' }
            }
          },
          {
            '@type': 'Question',
            '@id': 'https://www.medleve.com/dados#faq-6',
            url: 'https://www.medleve.com/dados#faq-6',
            position: 6,
            name: 'Com que frequência os dados são atualizados?',
            acceptedAnswer: {
              '@type': 'Answer',
              '@id': 'https://www.medleve.com/dados#faq-6-resposta',
              text: 'Todo mês, com um mês de defasagem. Cada edição fica arquivada em um endereço permanente.',
              author: { '@id': 'https://www.medleve.com/equipe-medica/carlos-seraphim#person' }
            }
          },
          {
            '@type': 'Question',
            '@id': 'https://www.medleve.com/dados#faq-7',
            url: 'https://www.medleve.com/dados#faq-7',
            position: 7,
            name: 'O que significa participação nas prescrições?',
            acceptedAnswer: {
              '@type': 'Answer',
              '@id': 'https://www.medleve.com/dados#faq-7-resposta',
              text: 'É a porcentagem das prescrições de GLP-1 do mês que corresponde a uma molécula ou marca. Por exemplo, 51% de tirzepatida significa que 51 de cada 100 prescrições de GLP-1 da Medleve no mês foram de tirzepatida.',
              author: { '@id': 'https://www.medleve.com/equipe-medica/carlos-seraphim#person' }
            }
          },
          {
            '@type': 'Question',
            '@id': 'https://www.medleve.com/dados#faq-8',
            url: 'https://www.medleve.com/dados#faq-8',
            position: 8,
            name: 'Os dados podem ser usados como recomendação médica?',
            acceptedAnswer: {
              '@type': 'Answer',
              '@id': 'https://www.medleve.com/dados#faq-8-resposta',
              text: 'Não. São dados observacionais de prescrição. A escolha de um tratamento depende de avaliação médica individual.',
              author: { '@id': 'https://www.medleve.com/equipe-medica/carlos-seraphim#person' }
            }
          },
          {
            '@type': 'Question',
            '@id': 'https://www.medleve.com/dados#faq-9',
            url: 'https://www.medleve.com/dados#faq-9',
            position: 9,
            name: 'Posso citar ou reutilizar os dados?',
            acceptedAnswer: {
              '@type': 'Answer',
              '@id': 'https://www.medleve.com/dados#faq-9-resposta',
              text: 'Sim, com atribuição: "Medleve. Observatório Medleve de GLP-1 — edição de agosto de 2026. Disponível em: https://www.medleve.com/dados/glp-1/2026-08. Acesso em: [data]." Os dados estão disponíveis para download em CSV e JSON.',
              author: { '@id': 'https://www.medleve.com/equipe-medica/carlos-seraphim#person' }
            }
          }
        ]
      },
      {
        '@type': 'Drug',
        '@id': 'https://www.medleve.com/semaglutida#entity',
        name: 'Semaglutida',
        url: 'https://www.medleve.com/semaglutida',
        drugClass: 'Agonista do receptor de GLP-1'
      },
      {
        '@type': 'Drug',
        '@id': 'https://www.medleve.com/tirzepatida#entity',
        name: 'Tirzepatida',
        url: 'https://www.medleve.com/tirzepatida',
        drugClass: 'Agonista dos receptores de GIP e GLP-1'
      },
      {
        '@type': 'Report',
        '@id': 'https://www.medleve.com/dados/glp-1/2026-08#relatorio',
        headline: 'Observatório Medleve de GLP-1 — edição de agosto de 2026',
        name: 'Observatório Medleve de GLP-1 — edição de agosto de 2026',
        url: 'https://www.medleve.com/dados/glp-1/2026-08',
        abstract:
          'Em agosto de 2026, a tirzepatida (Mounjaro) representou 51% das prescrições de GLP-1 observadas na Medleve, e a semaglutida, 49%. Mounjaro foi o medicamento mais prescrito (51%), seguido de Wegovy (19%), Ozivy (9%) e Poviztra (4%). 71% das prescrições foram de acompanhamento de tratamento já iniciado. Os dados são da plataforma Medleve e não representam o mercado brasileiro.',
        inLanguage: 'pt-BR',
        reportNumber: '2026-08',
        datePublished: '{{data_de_publicacao}}',
        dateModified: '{{data_de_publicacao}}',
        author: { '@id': 'https://www.medleve.com/equipe-medica/carlos-seraphim#person' },
        publisher: { '@id': 'https://www.medleve.com/#organization' },
        about: { '@id': 'https://www.medleve.com/dados/glp-1/2026-08#dataset' },
        isPartOf: { '@id': 'https://www.medleve.com/dados#catalogo' },
        mentions: [
          { '@id': 'https://www.medleve.com/dados/glp-1/2026-08#destaque-tirzepatida' },
          { '@id': 'https://www.medleve.com/dados/glp-1/2026-08#destaque-mounjaro' },
          { '@id': 'https://www.medleve.com/dados/glp-1/2026-08#destaque-wegovy' },
          { '@id': 'https://www.medleve.com/dados/glp-1/2026-08#destaque-ozivy' },
          { '@id': 'https://www.medleve.com/dados/glp-1/2026-08#destaque-continuidade' },
          { '@id': 'https://www.medleve.com/dados/glp-1/2026-08#destaque-retorno' }
        ]
      },
      {
        '@type': 'Observation',
        '@id': 'https://www.medleve.com/dados/glp-1/2026-08#destaque-tirzepatida',
        name: 'das prescrições de GLP-1 foram de tirzepatida',
        description:
          'Em agosto de 2026, a tirzepatida representou 51% das prescrições de GLP-1 observadas na Medleve, contra 48% no mês anterior e 35% em agosto de 2025.',
        observationDate: '2026-08',
        variableMeasured: 'Participação da tirzepatida nas prescrições de GLP-1 observadas na Medleve',
        value: { '@type': 'QuantitativeValue', value: 51, unitText: '%' },
        observationAbout: { '@id': 'https://www.medleve.com/tirzepatida#entity' },
        measurementMethod: 'https://www.medleve.com/dados#metodologia',
        url: 'https://www.medleve.com/dados#destaque-tirzepatida'
      },
      {
        '@type': 'Observation',
        '@id': 'https://www.medleve.com/dados/glp-1/2026-08#destaque-mounjaro',
        name: 'Mounjaro, o medicamento mais prescrito',
        description:
          'Mounjaro foi o medicamento mais frequente nas prescrições de GLP-1 da Medleve em agosto de 2026, com 51% do total.',
        observationDate: '2026-08',
        variableMeasured: 'Participação de Mounjaro nas prescrições de GLP-1 observadas na Medleve',
        value: { '@type': 'QuantitativeValue', value: 51, unitText: '%' },
        observationAbout: { '@type': 'Drug', name: 'Mounjaro', url: 'https://www.medleve.com/mounjaro' },
        measurementMethod: 'https://www.medleve.com/dados#metodologia',
        url: 'https://www.medleve.com/dados#destaque-mounjaro'
      },
      {
        '@type': 'Observation',
        '@id': 'https://www.medleve.com/dados/glp-1/2026-08#destaque-wegovy',
        name: 'Wegovy, contra 53% um ano antes',
        description:
          'A participação de Wegovy nas prescrições de GLP-1 observadas na Medleve passou de 53% em agosto de 2025 para 19% em agosto de 2026.',
        observationDate: '2026-08',
        variableMeasured: 'Participação de Wegovy nas prescrições de GLP-1 observadas na Medleve',
        value: { '@type': 'QuantitativeValue', value: 19, unitText: '%' },
        observationAbout: { '@type': 'Drug', name: 'Wegovy', url: 'https://www.medleve.com/wegovy' },
        measurementMethod: 'https://www.medleve.com/dados#metodologia',
        url: 'https://www.medleve.com/dados#destaque-wegovy'
      },
      {
        '@type': 'Observation',
        '@id': 'https://www.medleve.com/dados/glp-1/2026-08#destaque-ozivy',
        name: 'Ozivy, presente desde junho de 2026',
        description:
          'Ozivy, que aparece nas prescrições da Medleve desde junho de 2026, respondeu por 9% das prescrições de GLP-1 em agosto de 2026 (10% no mês anterior).',
        observationDate: '2026-08',
        variableMeasured: 'Participação de Ozivy nas prescrições de GLP-1 observadas na Medleve',
        value: { '@type': 'QuantitativeValue', value: 9, unitText: '%' },
        observationAbout: { '@type': 'Drug', name: 'Ozivy', url: 'https://www.medleve.com/ozivy' },
        measurementMethod: 'https://www.medleve.com/dados#metodologia',
        url: 'https://www.medleve.com/dados#destaque-ozivy'
      },
      {
        '@type': 'Observation',
        '@id': 'https://www.medleve.com/dados/glp-1/2026-08#destaque-continuidade',
        name: 'das prescrições foram de acompanhamento',
        description:
          'Em agosto de 2026, 71% das prescrições de GLP-1 da Medleve foram de acompanhamento (retorno) e 29% de início de tratamento.',
        observationDate: '2026-08',
        variableMeasured: 'Prescrições de GLP-1 de acompanhamento (retorno) na Medleve',
        value: { '@type': 'QuantitativeValue', value: 71, unitText: '%' },
        observationAbout: { '@id': 'https://www.medleve.com/dados/glp-1/2026-08#dataset' },
        measurementMethod: 'https://www.medleve.com/dados#metodologia',
        url: 'https://www.medleve.com/dados#destaque-continuidade'
      },
      {
        '@type': 'Observation',
        '@id': 'https://www.medleve.com/dados/glp-1/2026-08#destaque-retorno',
        name: 'voltaram em até 90 dias (coorte de maio de 2026)',
        description:
          'Entre pacientes que fizeram a primeira consulta na Medleve em maio de 2026, 29% voltaram para uma nova consulta em até 90 dias.',
        observationDate: '2026-08',
        variableMeasured: 'Pacientes com nova consulta em até 90 dias da primeira consulta na Medleve',
        value: { '@type': 'QuantitativeValue', value: 29, unitText: '%' },
        observationAbout: { '@id': 'https://www.medleve.com/dados/glp-1/2026-08#dataset' },
        measurementMethod: 'https://www.medleve.com/dados#metodologia',
        url: 'https://www.medleve.com/dados#destaque-retorno'
      },
      {
        '@type': 'BreadcrumbList',
        '@id': 'https://www.medleve.com/dados#breadcrumb',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Medleve', item: 'https://www.medleve.com/' },
          { '@type': 'ListItem', position: 2, name: 'Observatório de GLP-1', item: 'https://www.medleve.com/dados' }
        ]
      }
    ]
  },
  previousEditions: [{ version: '2026-08', label: 'agosto de 2026' }]
}
